import React, { useState, useEffect, useRef } from 'react';
import CustomRadio from './style';
import { Radio, Box } from '@mui/material';

const Label = ({ label, component }) => {
  return (
    <Box ml={1}>
      {label}
      <br />
      {component}
    </Box>
  );
};

export default function Index({ value, label, component, align, disable=false }) {
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(true);
  };
  const ref = useRef(null);

  useEffect(() => {
    const onClickOutside = () => {
      setClicked(false);
    };
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  return (
    <CustomRadio
      ref={ref}
      control={
        <Radio
        disabled={disable}
          onClick={handleClick}
          value={value}
          sx={{
            color: '#5E70CC',
            '&.Mui-checked': {
              color: '#5E70CC',
            },
          }}
        />
      }
      label={<Label label={label} component={component} />}
      sx={{
        alignItems: align && align,
      }}
    />
  );
}
